import moment from 'moment'
import { SkudConsumerTokenEndpoint } from '@/views/skud/shared/endpoint_services/skud-consumer-token-endpoint-service'
import { envelopeError } from '@/views/skud/shared/modules/skud-http'
import { ConsumerTokenMode, ConsumerTokenSource, enumText } from '@/views/skud/shared/models/enums'

const DATE_FMT = 'DD.MM.YYYY HH:mm:ss'

function fmt (v) {
  return v ? moment(v).format(DATE_FMT) : null
}

export class SkudConsumerTokenService {
  constructor () {
    this.endpoint = new SkudConsumerTokenEndpoint()
    this.error = null
  }

  // body: {name?, place_ids[], mode, expires_at?} -> {ok, data:{token,...}} | {ok, error}.
  async createToken (placeId, body) {
    return this.endpoint.createToken(placeId, body)
  }

  async getTokens (placeId) {
    const res = await this.endpoint.getTokens(placeId)
    if (!res) {
      this.error = envelopeError(this.endpoint.lastError)
      return { tokens: [] }
    }
    this.error = null
    const tokens = (res.tokens || []).map(x => ({
      id: x.id,
      name: x.name,
      place_ids: x.place_ids || [],
      mode: x.mode,
      mode_text: enumText(ConsumerTokenMode, x.mode),
      source: x.source,
      source_text: enumText(ConsumerTokenSource, x.source),
      created_at: fmt(x.created_at),
      expires_at: fmt(x.expires_at),
      last_used_at: fmt(x.last_used_at),
      use_count: x.use_count
    }))
    return { tokens: tokens }
  }

  // -> {ok:true} | {ok:false, error}.
  async deleteToken (placeId, id) {
    return this.endpoint.deleteToken(placeId, id)
  }
}
